import React from "react";
import { optimizeCloudinaryImage } from "@/services/CloudinaryService";
import { Lazy } from "@/components/Lazy";

import { FeedbackHeroProps } from "./types";
import { FEEDBACK_PREVIEW_INDEX } from "@/utils/feedbackPreviewNavigation";

export const FeedbackHero = ({ data, currentView, isInitPreview }: FeedbackHeroProps) => {
  const { logoUrl, themeColor } = data;

  if (!logoUrl) return <></>;
  return (
    <div
      className={`feedback-template__hero-container ${
        currentView === FEEDBACK_PREVIEW_INDEX.THANK_YOU
          ? "feedback-template__hero-container--thank-you"
          : ""
      } `}
      style={{ background: themeColor?.backgroundColor }}
    >
      {logoUrl &&
        (isInitPreview ? (
          <Lazy placeholderClass="skeleton-placeholder__links__image">
            <img
              src={logoUrl}
              alt="feedback preview"
            />
          </Lazy>
        ) : (
          <Lazy placeholderClass="feedback-template__logo">
            <img
              src={optimizeCloudinaryImage({
                url: logoUrl,
              })}
              className="feedback-template__logo"
            />
          </Lazy>
        ))}
    </div>
  );
};
